import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility.js';

const initialState = {
    machine: {},
    loading: false,
    error: false,
    created: false,
    fetched: false,
    deleted: false,
    name_available: true,
    name_checked: false
};

/* ------------------ Machine Create ------------------- */
const calculatorMachineCreateStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, created: false, machine: {} } );
};

const calculatorMachineCreateReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, created: false, machine: {} } );
};

const calculatorMachineCreateSuccess = ( state, action ) => {
    return updateObject( state, {
	    machine: action.machine,
        loading: false,
        error: false,
        created: true
    } );
};

const calculatorMachineCreateFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

/* ----------------- Machine Duplicate ------------------ */
const calculatorMachineDuplicateCheckStart = ( state, action ) => {
    return updateObject( state, { loading: true, name_available: true, error: false, name_checked: false } );
};

const calculatorMachineDuplicateCheckSuccess = ( state, action ) => {
    return updateObject( state, {
        name_available: !action.name_duplicate,
        name_checked: true
    } );
};

const calculatorMachineDuplicateCheckFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const calculatorMachineDuplicateCheckReset = ( state, action ) => {
    return updateObject( state, { name_available: true, name_checked: false } );
};

/* ------------------ Machine Update ------------------- */
const calculatorMachineUpdateStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, updated: false } );
};

const calculatorMachineUpdateReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, updated: false } );
};

const calculatorMachineUpdateSuccess = ( state, action ) => {
    return updateObject( state, {
        machine: action.machine,
        loading: false,
        error: false,
        updated: true
    } );
};

const calculatorMachineUpdateFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

/* ------------------ Machine Delete ------------------- */
const calculatorMachineDeleteStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, deleted: false} );
};

const calculatorMachineDeleteReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, deleted: false } );
};

const calculatorMachineDeleteSuccess = ( state, action ) => {
    return updateObject( state, {
        loading: false,
        error: false,
        deleted: true
    } );
};

const calculatorMachineDeleteFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

/* ------------------ Machine Fetch ------------------- */
const calculatorMachineFetchStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, fetched: false, machine: {} } );
};

const calculatorMachineFetchReset = ( state, action ) => {
    return updateObject( state, { loading: false, error: false, fetched: false, machine: {} } );
};

const calculatorMachineFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        machine: action.machine,
        loading: false,
        error: false,
        fetched: true
    } );
};

const calculatorMachineFetchFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
    	case actionTypes.CALCULATOR_MACHINE_CREATE_START: return calculatorMachineCreateStart( state, action );
    	case actionTypes.CALCULATOR_MACHINE_CREATE_SUCCESS: return calculatorMachineCreateSuccess( state, action );
    	case actionTypes.CALCULATOR_MACHINE_CREATE_FAIL: return calculatorMachineCreateFail( state, action );
        case actionTypes.CALCULATOR_MACHINE_CREATE_RESET: return calculatorMachineCreateReset( state, action );
        case actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_START: return calculatorMachineDuplicateCheckStart( state, action );
        case actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS: return calculatorMachineDuplicateCheckSuccess( state, action );
        case actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_FAIL: return calculatorMachineDuplicateCheckFail( state, action );
        case actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_RESET: return calculatorMachineDuplicateCheckReset( state, action );
        case actionTypes.CALCULATOR_MACHINE_UPDATE_START: return calculatorMachineUpdateStart( state, action );
        case actionTypes.CALCULATOR_MACHINE_UPDATE_SUCCESS: return calculatorMachineUpdateSuccess( state, action );
        case actionTypes.CALCULATOR_MACHINE_UPDATE_FAIL: return calculatorMachineUpdateFail( state, action );
        case actionTypes.CALCULATOR_MACHINE_UPDATE_RESET: return calculatorMachineUpdateReset( state, action );
        case actionTypes.CALCULATOR_MACHINE_FETCH_START: return calculatorMachineFetchStart( state, action );
        case actionTypes.CALCULATOR_MACHINE_FETCH_SUCCESS: return calculatorMachineFetchSuccess( state, action );
        case actionTypes.CALCULATOR_MACHINE_FETCH_FAIL: return calculatorMachineFetchFail( state, action );
        case actionTypes.CALCULATOR_MACHINE_FETCH_RESET: return calculatorMachineFetchReset( state, action );
        case actionTypes.CALCULATOR_MACHINE_DELETE_START: return calculatorMachineDeleteStart( state, action );
        case actionTypes.CALCULATOR_MACHINE_DELETE_SUCCESS: return calculatorMachineDeleteSuccess( state, action );
        case actionTypes.CALCULATOR_MACHINE_DELETE_FAIL: return calculatorMachineDeleteFail( state, action );
        case actionTypes.CALCULATOR_MACHINE_DELETE_RESET: return calculatorMachineDeleteReset( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/calculator/machines/machine.js